import React from "react";
import ContentContainer from "components/Container";
import { IFrameFooterWithLogo } from "components/Footer";

export const IFrame = ({ children }) => {
  return (
    <ContentContainer data-testid="pm-iframe">
      <>
        {children}
        <IFrameFooterWithLogo />
      </>
    </ContentContainer>
  );
};
